/**
 * Ejecuta tareas async con límite de concurrencia (evita saturar API / main thread).
 */
export async function runWithConcurrency<T>(
  tasks: Array<() => Promise<T>>,
  limit = 6,
): Promise<T[]> {
  if (!tasks.length) return []

  const results = new Array<T>(tasks.length)
  let nextIndex = 0

  async function worker() {
    while (nextIndex < tasks.length) {
      const index = nextIndex++
      results[index] = await tasks[index]()
    }
  }

  const workers = Math.min(Math.max(1, limit), tasks.length)
  await Promise.all(Array.from({ length: workers }, () => worker()))
  return results
}
